export const SettlementConfirmation = {
  SettlementDetail: {
    SettlementContent: 'お薬代のお支払い',
    CreditUpdateButton: 'カード情報の更新',
    SettlementButton: '支払う',
  },
  Message: {
    Description:
      '請求内容をご確認の上、「支払う」ボタンを押してください。金額が正しくない場合やご質問がある場合は薬局までお問い合わせください。',
    NoCardInfo: '※クレジットカード情報の再登録をお願いします。',
    SettlementError: 'クレジットカード決済時にエラーが発生しました。',
    SettlementErrorCode: 'エラーコード:{0}',
  },
  PaymentDetail: {
    TotalPayment: '請求金額',
    Medicine: 'お薬代',
    DeliveryPrice: '配送料金',
    Others: 'その他',
    Yen: '円',
  },
  CreditCard: {
    Label: 'クレジットカード情報',
    Number: 'カード番号',
    ExpiredDate: '有効期限',
    Brand: 'ブランド',
    Cardholder: 'カード名義人',
  },
  ConfirmSettlementCard: {
    ButtonTitle: 'お薬代を支払う',
  },
};
